import React from "react";
import PropTypes from "prop-types";
import { useI18n } from "../../spages/spa/context/I18nContext";
import Img from "../Img/Img";
import ReadMore from "../ReadMore/ReadMore";

const features = [
  {
    image: { url: "/public/images/partners/google.png", alt: "Google" },
    href: "http://google.com",
  },
  {
    image: { url: "/public/images/partners/microsoft.png", alt: "Microsoft" },
    href: "http://microsoft.com",
  },
  {
    image: { url: "/public/images/partners/santander.png", alt: "Santander" },
    href: "https://www.santander.de",
  },
  {
    image: {
      url: "/public/images/partners/alex-springer.png",
      alt: "Alex Springer",
    },
    href: "http://www.axelspringer.de/",
  },
  {
    image: {
      url: "/public/images/partners/book-a-tiger.png",
      alt: "Book a tiger",
    },
    href: "https://www.bookatiger.com",
  },
];

const hidden = [
  {
    image: { url: "/public/images/partners/zalando.png", alt: "Zalando" },
    href: "https://www.zalando.com",
  },
  {
    image: { url: "/public/images/partners/number-26.png", alt: "Number 26" },
    href: "https://n26.com/",
  },
  {
    image: {
      url: "/public/images/partners/start-relocation-service.png",
      alt: "Start relocation service",
    },
    href: "http://www.start-relocation.de/",
  },
  {
    image: {
      url: "/public/images/partners/travel-audience.png",
      alt: "Travel audience",
    },
    href: "https://travelaudience.com/",
  },
  {
    image: { url: "/public/images/partners/windeln.png", alt: "Windeln" },
    href: "http://www.windeln.de/",
  },
  {
    image: { url: "/public/images/partners/move24.png", alt: "Move24" },
    href: "https://www.move24.com",
  },
  {
    image: { url: "/public/images/partners/mindspace.png", alt: "Mindspace" },
    href: "http://mindspace.me",
  },
];

const FeaturedCompanies = ({ className }) => {
  const { t } = useI18n();

  return (
    <div className={`FeaturedCompanies${className ? ` ${className}` : ""}`}>
      <h3 className="heading-large heading-large--bold">
        {t("components.FeaturedCompanies.title")}
      </h3>
      <div className="FeaturedCompanies-wrapper">
        {features.map((feature, i) => (
          <div key={i} className="FeaturedCompanies-feature">
            <Img src={feature.image.url} alt={feature.image.alt} />
          </div>
        ))}
        <ReadMore
          labels={{
            visible: t("showLess"),
            hidden: t("showMore"),
          }}
        >
          {hidden.map((hidden, i) => (
            <div key={i} className="FeaturedCompanies-feature">
              <Img src={hidden.image.url} alt={hidden.image.alt} />
            </div>
          ))}
        </ReadMore>
      </div>
    </div>
  );
};

FeaturedCompanies.propTypes = {
  className: PropTypes.string,
};

export default FeaturedCompanies;
